import { render, staticRenderFns } from "./InfoPagamento.vue?vue&type=template&id=6a632032&scoped=true&"
import script from "./InfoPagamento.vue?vue&type=script&lang=js&"
export * from "./InfoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a632032",
  null
  
)

export default component.exports